module.exports = __webpack_public_path__ + "static/media/Violette NOP to Revoke_Redacted.a994119e.pdf";